import { Component } from '@angular/core';
import { User } from '../model/user.class';
import { UserService} from '../services/user.service';
import { ShaService} from '../services/sha.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {

  mail: String;
  password: String;
  message: String = '';
  shaService: ShaService;

  constructor(public userService: UserService) {
  }

  login() {
    this.shaService = new ShaService();
    let hashedPassword = this.shaService.SHA256(this.password);
    this.userService.login(this.mail, hashedPassword);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts